import React from 'react'
import Icon from '@mdi/react'
import { mdiHistory, mdiClipboardListOutline } from '@mdi/js'
import OviyamNgSeriesPane from './OviyamNgSeriesPane'
import { t } from '../../i18n'

/**
 * West pane Oviyam: solo metadata del estudio + series (explorer).
 * Tools clínicos viven en el rail derecho / header.
 */
function OviyamNgSidebar({
  title,
  subtitle,
  patientId,
  onSelectSeries,
  autoSelectFirstSeries,
  activeSliceIndex = 0,
  showRelatedStudies = false,
  relatedStudiesCount = 0,
  onRelatedStudies,
  showWorklist = false,
  worklistCount = 0,
  onWorklist,
  collapsedStudyKeys,
  onToggleStudyCollapse,
  viewportStudyUids,
  suggestedPriorSeriesKey,
  onOpenSuggestedInCompare,
}) {
  return (
    <aside className="udv-oviyamng-sidebar" aria-label="Estudio">
      <section className="udv-oviyamng-side-sec is-meta">
        <div className="udv-oviyamng-side-title">Estudio</div>
        <div className="udv-oviyamng-meta-row">
          <strong>{title || 'Sin estudio'}</strong>
        </div>
        {patientId ? (
          <div className="udv-oviyamng-meta-row udv-oviyamng-meta-muted">
            ID: {patientId}
          </div>
        ) : null}
        {subtitle ? (
          <div className="udv-oviyamng-meta-row udv-oviyamng-meta-muted">{subtitle}</div>
        ) : null}
        {showRelatedStudies ? (
          <button
            type="button"
            className="udv-oviyamng-historial-chip"
            onClick={() => onRelatedStudies && onRelatedStudies()}
            title={t('relatedStudies.menuTooltip')}
            aria-label={t('relatedStudies.menu')}
          >
            <Icon path={mdiHistory} size={0.65} color="currentColor" />
            <span>
              {t('relatedStudies.chip')}
              {relatedStudiesCount > 0 ? ` (${relatedStudiesCount})` : ''}
            </span>
          </button>
        ) : null}
        {showWorklist ? (
          <button
            type="button"
            className="udv-oviyamng-historial-chip"
            onClick={() => onWorklist && onWorklist()}
            title={t('worklist.menuTooltip')}
            aria-label={t('worklist.menu')}
          >
            <Icon path={mdiClipboardListOutline} size={0.65} color="currentColor" />
            <span>
              {t('worklist.chip')}
              {worklistCount > 0 ? ` (${worklistCount})` : ''}
            </span>
          </button>
        ) : null}
      </section>

      <section className="udv-oviyamng-side-sec is-series">
        <div className="udv-oviyamng-side-title">Series</div>
        <div className="udv-oviyamng-series-body">
          <OviyamNgSeriesPane
            onSelectSeries={onSelectSeries}
            autoSelectFirstSeries={autoSelectFirstSeries}
            activeSliceIndex={activeSliceIndex}
            collapsedStudyKeys={collapsedStudyKeys}
            onToggleStudyCollapse={onToggleStudyCollapse}
            viewportStudyUids={viewportStudyUids}
            suggestedPriorSeriesKey={suggestedPriorSeriesKey}
            onOpenSuggestedInCompare={onOpenSuggestedInCompare}
          />
        </div>
      </section>
    </aside>
  )
}

export default OviyamNgSidebar
